import Waiting from '@/store/waiting';

export default class ClientAvailableFeatureActions {
  constructor (Api, types) {
    const actions = {
      async getClientAvailableFeatureAction ({ commit }, args) {
        await waiting.check('getClientAvailableFeatureAction', async () => {
          try {
            const res = await Api.getClientAvailableFeatures(args);
            commit(types.SET_CLIENT_AVAILABLE_FEATURE, Object.values(res.data)[0]);
          } catch (err) {
            throw err;
          }
        });
      },

      async updateClientAvailableFeatureAction ({ dispatch }, args) {
        await waiting.check('updateClientAvailableFeatureAction', async () => {
          await Api.updateClientAvailableFeature(args);
          try {
            await dispatch('getClientAvailableFeatureAction', args);
          } catch (err) {
            throw err;
          }
        });
      },
    };
    const waiting = new Waiting(actions);
    this.actions = actions;
  }
}
